export const GIT_SETTINGS_MODES = {
  ORG: 'ORG',
  TEAM: 'TEAM'
};

export const isTeamModeHandler = modeHandler =>
  modeHandler?.type === GIT_SETTINGS_MODES.TEAM;
